<template>
    <div class="info_service">
        <pop :is-pop-show.sync = 'showOrder' @on-sure = 'closeOrder' :is-show-cancel="false" sureBtn_zh="确定" sureBtn_hk="確定">
            <div class="server-orderbox" slot="xw-pop-modal-body">
                <h3>{{$lang == 'zh' ? '学生体验卡转换校园棒棒糖计划教程' : '學生體驗卡轉換校園棒棒糖計劃教程'}}:</h3>
                <div class="appyour-cont">
                    <p>
                        {{$lang == 'zh' ?
                         '1.前往官网：https://www.ctexcel.com.hk/ ；'
                         : 
                         '1.前往官網：https://www.ctexcel.com.hk/ ；'
                         }}
                    </p>
                   <p>
                        {{$lang == 'zh' ?
                         '2.点击：我的CTExcel ；'
                         : 
                         '2.點擊：我的CTExcel；'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '3.进入登录界面，点击“首次登录”；'
                         : 
                         '3.進入登錄頁面，點擊“首次登錄”；'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '4.输入手机号码、获取验证码并输入验证码登入后设置账户密码；'
                         : 
                         '4.輸入手機號碼、獲取驗證碼並輸入驗證碼登入後設置賬戶密碼；'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '5.进入个人中心页面后，点击“客户服务”下方“转换月费计划”；'
                         : 
                         '5.進入個人中心頁面後，點擊“客戶服務”下方“轉換月費計劃”；'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '6.勾选所需转换的月费计划之后点击下方“立即转换”；'
                         : 
                         '6.勾選所需轉換的月費計劃之後點擊下方“立即轉換”；'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '7.填写转换月费计划所需的个人资料及服务信息并付款；'
                         : 
                         '7.填寫轉換月費計劃所需的個人資料及服務信息並付款；'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '8.付款成功后将收到服务确认邮件。'
                         : 
                         '8.付款成功後將受到服務確認郵件。'
                         }}
                    </p>
                </div>
            </div>
        </pop>
    </div>
</template>

<script>
    import pop from './pop.vue'
    export default {
        components: {
            pop
        },
        props: ['showOrder'],
        watch: {
            showOrder () {
                this.$emit('changeOrder',this.showOrder);
            }
        },
        data () {
            return {
            }
        },
        computed: {
            $lang () {
                return this.$i18n.locale == "zh" ? 'zh' : 'hk';
            }
        },
        methods: {
            closeOrder () {
                this.showOrder = false
            }
        }
    }
</script>

<style scoped lang="less">
.server-orderbox {
    width: 870px;
    padding: 0 35px 35px;
    h3 {
        text-align: center;
        font-size: 16px;
        padding: 10px 0 20px;
        border-bottom: 1px solid #eaeaea;
    }
    .appyour-cont {
        max-height: 60vh;
        padding-top: 20px;
        overflow-y: auto;
        p {
            font-size: 12px;
            line-height: 20px;
            color: #666;
        }
        
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/studyStep.vue